export default __webpack_public_path__ + "static/media/PsychAssoc_logo_full_alt.012bcf13.png";